import { CommonModule, DecimalPipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SkipSelf, APP_INITIALIZER, NgModule, Optional } from '@angular/core';
import {
  ContentStoreService,
  graphqlConfigFactory,
  MxLibraryAngularModule,
  CmsTranslateLoaderFactory,
} from '@motivforce/mx-library-angular';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular-link-http';
import { SharedModule } from 'primeng-lts/api';
import { environment } from 'src/environments/environment';

import { DefaultContentTemplateComponent } from './components/default-content-template/default-content-template.component';
import { DistributorReferralPageComponent } from './components/distributor-referral-page/distributor-referral-page.component';
import { DialogModule } from './dialog/dialog.module';
import { awsInitializerFactory } from './factory/aws-initializer.factory';
import { CustomHttpTokenInterceptor } from './interceptors/custom-http-token.interceptor';
import { LayoutModule } from './layout/layout.module';

@NgModule({
  declarations: [DefaultContentTemplateComponent, DistributorReferralPageComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: CmsTranslateLoaderFactory,
        deps: [Apollo, ContentStoreService],
      },
    }),
    MxLibraryAngularModule.forRoot({ environment }),
    LayoutModule,
    DialogModule,
    SharedModule,
  ],
  exports: [LayoutModule],
  providers: [
    HttpLink,
    {
      provide: APP_INITIALIZER,
      useFactory: awsInitializerFactory,
      deps: [],
      multi: true,
    },
    {
      provide: APOLLO_OPTIONS,
      useFactory: graphqlConfigFactory,
      deps: [HttpLink],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpTokenInterceptor,
      multi: true,
    },
    DecimalPipe,
  ],
})
export class CoreModule {
  constructor(contentStore: ContentStoreService, @Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      throw new Error('You should import core module only once in the root module');
    }

    contentStore.registerTemplate('defaultTemplate', DefaultContentTemplateComponent);
  }
}
